import script from "./CompanyModalSimple.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyModalSimple.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyModalSimple.vue?vue&type=style&index=0&id=13500228&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13500228"]])

export default __exports__